import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/data.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-wizardlayoutlist',
  templateUrl: './wizardlayoutlist.component.html',
  styleUrls: ['./wizardlayoutlist.component.scss']
})
export class WizardlayoutlistComponent implements OnInit {

  displayedColumns: string[] = [
    "labelname",
    "parentobject",
    "createdby",
    "createddate",
    // "actions",
  ];
  dataSource: any[] = [];

  isLoading = false;
  isError = false;
  errorMessage = "";
  reportId = "";
  mode = "";
  dashboards = [];
  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  ngOnInit() {
  }

  new() {
    this.router.navigateByUrl("/home/wizardlayout/new");
  }

}
